module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('Dialog', {
    style: ({
      width: '35vw'
    }),
    attrs: {
      "visible": _vm.printDialog,
      "header": "Do you want to print this bill?",
      "modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.printDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "label": "Yes",
      "icon": "pi pi-check"
    },
    on: {
      "click": _vm.printBill
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "icon": "pi pi-times",
      "label": "No"
    },
    on: {
      "click": _vm.closePrintDialog
    }
  })], 1)])]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "transactionDate"
    }
  }, [_vm._v("Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "tran",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  }) : _c('InputMask', {
    ref: "tran",
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "transactionDate"
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "transactionDate"
    }
  }, [_vm._v("Purchase Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "purchaseSalesDate"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "billNo"
    }
  }, [_vm._v("Bill No")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "billNo",
      "disabled": ""
    },
    model: {
      value: (_vm.billNo),
      callback: function($$v) {
        _vm.billNo = $$v
      },
      expression: "billNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "refno"
    }
  }, [_vm._v("Ref. No.")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "refno"
    },
    model: {
      value: (_vm.refNo),
      callback: function($$v) {
        _vm.refNo = $$v
      },
      expression: "refNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "purType"
    }
  }, [_vm._v("Pur Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taxType),
      expression: "taxType"
    }],
    staticClass: "form-control ",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.taxType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select One")]), _vm._v(" "), _vm._l((_vm.taxTypeList), function(tax, ind) {
    return _c('option', {
      key: ind
    }, [_vm._v(_vm._s(tax.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "purType"
    }
  }, [_vm._v("Manual Entry")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "binary": true
    },
    model: {
      value: (_vm.dairyManualEntry),
      callback: function($$v) {
        _vm.dairyManualEntry = $$v
      },
      expression: "dairyManualEntry"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', [_vm._v("Supplier Type")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.supplierTypeList,
      "optionLabel": "label",
      "optionValue": "value",
      "filter": true,
      "placeholder": "Select Type",
      "showClear": true
    },
    model: {
      value: (_vm.supplierType),
      callback: function($$v) {
        _vm.supplierType = $$v
      },
      expression: "supplierType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', [_vm._v("Shift")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.shiftList,
      "optionLabel": "label",
      "optionValue": "value",
      "filter": true,
      "placeholder": "Select Shift",
      "showClear": true
    },
    model: {
      value: (_vm.shift),
      callback: function($$v) {
        _vm.shift = $$v
      },
      expression: "shift"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "warehouse"
    }
  }, [_vm._v("Store")]), _vm._v(" "), (!_vm.setWarehouseData) ? _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select store",
      "showClear": true
    },
    model: {
      value: (_vm.warehouse),
      callback: function($$v) {
        _vm.warehouse = $$v
      },
      expression: "warehouse"
    }
  }) : _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select warehouse",
      "disabled": true
    },
    model: {
      value: (_vm.warehouse),
      callback: function($$v) {
        _vm.warehouse = $$v
      },
      expression: "warehouse"
    }
  })], 1), _vm._v(" "), _c('wearhouseDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Warehouse'),
      expression: "'Add Warehouse'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "p-mt-5",
    staticStyle: {
      "margin-right": "-10em"
    },
    on: {
      "set_data_warehouse": _vm.set_data_warehouse
    }
  })], 1), _vm._v(" "), (!_vm.ifNotCash) ? _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [(_vm.accountMaster.id > 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "panNo"
    }
  }, [_vm._v("Tax No:")]), _vm._v(" "), _c('b', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.accountMaster.panNo))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "panNo"
    }
  }, [_vm._v("Cur. Bal:")]), _vm._v(" "), (_vm.accountMaster.closingBalance > 0) ? _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                    " + _vm._s((_vm.accountMaster.closingBalance).toFixed(2) + 'Cr') + "\n                  ")]) : _c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                    " + _vm._s((_vm.accountMaster.closingBalance * (-1)).toFixed(2) + 'Dr') + "\n                  ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(0), _vm._v(" "), _c('AutoComplete', {
    ref: "itm",
    attrs: {
      "filterMatchMode": "contains",
      "suggestions": _vm.filteredItems,
      "field": "name"
    },
    on: {
      "complete": function($event) {
        return _vm.searchItem($event)
      }
    },
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  })], 1), _vm._v(" "), _c('itemDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Item'),
      expression: "'Add Item'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "p-mt-5",
    staticStyle: {
      "margin-right": "-10em"
    },
    on: {
      "set_data_item": _vm.set_data_item
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "qty"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "qty",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('label', {
    attrs: {
      "for": "unit"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "unit",
      "disabled": ""
    },
    model: {
      value: (_vm.items.unitName),
      callback: function($$v) {
        _vm.$set(_vm.items, "unitName", $$v)
      },
      expression: "items.unitName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "rate"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "rate",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = $$v
      },
      expression: "rate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "total"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "disabled": "",
      "id": "total",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "label": !_vm.editDTO ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItemToDTOList.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "label": "Details"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasicBatchDetails.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [(_vm.editDTO) ? _c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": _vm.itemDTOreset
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.findRate))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(" " + _vm._s(_vm.totalAmount))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.setRateFromItem))]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "avl"
    }
  }, [_vm._v("Cur. Stock:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.items.closingStock))])]), _vm._v(" "), (_vm.dairyManualEntry) ? _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "shortName"
    }
  }, [_vm._v("FAT %")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "ccPercentage",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.fatPercentage),
      callback: function($$v) {
        _vm.fatPercentage = $$v
      },
      expression: "fatPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "manufactureDate"
    }
  }, [_vm._v("FAT Rate")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "ccPercentage",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.fatRate),
      callback: function($$v) {
        _vm.fatRate = $$v
      },
      expression: "fatRate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "expiryDate"
    }
  }, [_vm._v("SNF %")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "ccPercentage",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.snfPercentage),
      callback: function($$v) {
        _vm.snfPercentage = $$v
      },
      expression: "snfPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "shortName"
    }
  }, [_vm._v("SNF Rate")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "free",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.snfRate),
      callback: function($$v) {
        _vm.snfRate = $$v
      },
      expression: "snfRate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "ccPercentage"
    }
  }, [_vm._v("TS %")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "ccPercentage",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.tsPercentage),
      callback: function($$v) {
        _vm.tsPercentage = $$v
      },
      expression: "tsPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "ccPercentage"
    }
  }, [_vm._v("TS Rate")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "ccPercentage",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.tsRate),
      callback: function($$v) {
        _vm.tsRate = $$v
      },
      expression: "tsRate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "ccPercentage"
    }
  }, [_vm._v("Rate Adjust")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "ccPercentage",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.rateAdjustment),
      callback: function($$v) {
        _vm.rateAdjustment = $$v
      },
      expression: "rateAdjustment"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.dairyManualEntry) ? _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [(_vm.supplierType == 'Kishan') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('a', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "download": "milkSupplierKishan.xlsx",
      "href": "../../../../static/excelFormat/milkSupplierKishan.xlsx"
    }
  }, [_vm._v("Download Format")])]) : _vm._e(), _vm._v(" "), (_vm.supplierType == 'Kishan') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.supplierType == 'Sanstha') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('a', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "download": "milkSupplierSanstha.xlsx",
      "href": "../../../../static/excelFormat/milkSupplierSanstha.xlsx"
    }
  }, [_vm._v("Download Format")])]) : _vm._e(), _vm._v(" "), (_vm.supplierType == 'Sanstha') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChangeSanstha
    }
  })]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('5.31')) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "id": "imageUpload",
      "label": "Upload Image"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showItemUpload.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Item Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Qty (Ltr)")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Fat %")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Fat")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Snf %")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Snf")]), _vm._v(" "), (_vm.supplierType == 'Sanstha') ? _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Ts %")]) : _vm._e(), _vm._v(" "), (_vm.supplierType == 'Sanstha') ? _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Ts")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Extra")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.inventoryInOutDetailList), function(item, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemMaster.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.supplierName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.fatPercentage))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.fatAmount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.snfPercentage))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.snfAmount))]), _vm._v(" "), (_vm.supplierType == 'Sanstha') ? _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.tsPercentage))]) : _vm._e(), _vm._v(" "), (_vm.supplierType == 'Sanstha') ? _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.tsAmount))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.rateAdjustment))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.rate))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s((item.rate * item.quantity).toFixed(4)) + " ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('Button', {
      staticClass: "p-button-raised p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          return _vm.editItemFromDTO(item, index)
        }
      }
    }), _vm._v(" "), (_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "disabled": "",
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.removeItemFromDTO(item, index)
        }
      }
    }) : (!_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.removeItemFromDTO(item, index)
        }
      }
    }) : _vm._e()], 1)])])
  })], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "16em"
    }
  }, [_vm._v(_vm._s(_vm.totalQty))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "38em"
    }
  }, [_vm._v(_vm._s(_vm.subTotal.toFixed(4)))])])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Narration")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.narration),
      expression: "narration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.narration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.narration = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "icon": "pi pi-save",
      "label": _vm.purchaseInvoice === undefined ? 'Save' : 'Update'
    },
    on: {
      "click": _vm.addPurchaseInvoice
    }
  })], 1), _vm._v(" "), (_vm.purchaseInvoice == undefined) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-warning",
    attrs: {
      "label": "Reset",
      "icon": "pi pi-refresh"
    },
    on: {
      "click": _vm.reset
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.purchaseInvoice != undefined) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "label": "Print",
      "icon": "pi pi-print"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [(_vm.saved) ? _c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "icon": "pi pi-download",
      "label": "Generate PDF"
    },
    on: {
      "click": _vm.printBill
    }
  }) : _c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "icon": "pi pi-download",
      "disabled": "",
      "label": "Generate PDF"
    },
    on: {
      "click": _vm.printBill
    }
  })], 1)])], 1), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Item Image Upload",
      "modal": true,
      "visible": _vm.showItemUploadDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showItemUploadDialog = $event
      }
    }
  }, [_c('input', {
    staticStyle: {
      "margin-bottom": "2em"
    },
    attrs: {
      "id": "imageUpload",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.onFileSelect
    }
  }), _vm._v(" "), _c('Carousel', {
    attrs: {
      "value": _vm.url,
      "numVisible": 2,
      "numScroll": 2
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "product-item"
        }, [_c('div', {
          staticClass: "product-item-content"
        }, [_c('div', {
          staticClass: "p-mb-3"
        }, [_c('img', {
          staticClass: "product-image",
          staticStyle: {
            "height": "250px",
            "width": "250px"
          },
          attrs: {
            "src": slotProps.data
          }
        })]), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "car-buttons p-mt-5"
        }, [_c('Button', {
          staticClass: "p-button-raised p-button-danger p-mr-2",
          attrs: {
            "label": "Remove"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeImage(slotProps.data, slotProps)
            }
          }
        })], 1)])])])]
      }
    }])
  })], 1), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "View Image ",
      "modal": true,
      "visible": _vm.openImageViewer
    },
    on: {
      "update:visible": function($event) {
        _vm.openImageViewer = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Back"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.back.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [(this.imageList.length > 0) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('Carousel', {
    attrs: {
      "value": _vm.imageList,
      "numVisible": 2,
      "numScroll": 2
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "product-item"
        }, [_c('div', {
          staticClass: "product-item-content"
        }, [_c('div', {
          staticClass: "p-mb-3"
        }, [_c('img', {
          staticClass: "product-image",
          staticStyle: {
            "height": "250px",
            "width": "250px"
          },
          attrs: {
            "src": slotProps.data.name
          }
        })]), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "car-buttons p-mt-5"
        }, [_c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Remove"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeImage(slotProps.data, slotProps)
            }
          }
        })], 1)])])])]
      }
    }], null, false, 1189475816)
  })], 1)]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "itm"
    }
  }, [_vm._v("Item"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "15em"
    }
  }, [_vm._v("Total:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bbbdaa7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/purchase/dairyPurchaseInvoice.vue
// module id = 2292
// module chunks = 0